<template>
  <div :class="appModifiers">
    <template v-if="!isSimpleLayout">
      <maintenance-notification></maintenance-notification>
      <div class="app-layout__search-overlay" v-if="searchBarVisible"></div>
      <search-bar></search-bar>
      <div class="app-layout__notifications">
        <transition name="app-layout-side-notification">
          <side-notification
            v-if="sideNotificationShouldDisplay"
            :level="sideNotificationLevel"
            :text="sideNotificationText"
            :sideNotificationOnCloseCallback="sideNotificationOnCloseCallback"
          ></side-notification>
        </transition>
        <notification-items></notification-items>
      </div>
      <div :class="headerModifiers">
        <app-header-notification v-if="!mobileMenuOpened"></app-header-notification>
        <app-header></app-header>
        <app-secondary-nav></app-secondary-nav>
      </div>
    </template>
    <transition
      name="app-layout"
      mode="out-in"
      @before-leave="onBeforeLeave"
      @after-enter="onAfterEnter"
    >
      <div :class="contentModifiers" :key="routeKey">
        <app-mobile-menu></app-mobile-menu>
        <div class="app-layout__container">
          <transition name="slide-left">
            <div v-if="showLeftPanel" class="app-layout__left">
              <div class="app-layout__rail-inner" :ref="(el) => setRailInnerRef('left', el)">
                <pinboard-panel
                  :showMenu="true"
                  :hideWhenNoItemsSelected="activePinboardConfig.hideLeftWhenEmpty"
                  side="left"
                ></pinboard-panel>
                <pinboard-panel
                  v-if="inSinglePanelMode"
                  :showMenu="true"
                  :hideWhenNoItemsSelected="activePinboardConfig.hideRightWhenEmpty"
                  side="right"
                ></pinboard-panel>
              </div>
            </div>
          </transition>

          <div class="app-layout__main">
            <!-- main content -->
            <router-view></router-view>
          </div>

          <transition name="slide-right">
            <div v-if="showRightPanel" class="app-layout__right">
              <div class="app-layout__rail-inner" :ref="(el) => setRailInnerRef('right', el)">
                <pinboard-panel
                  v-if="inSinglePanelMode"
                  :showMenu="true"
                  :hideWhenNoItemsSelected="activePinboardConfig.hideLeftWhenEmpty"
                  side="left"
                ></pinboard-panel>
                <pinboard-panel
                  :showMenu="true"
                  :hideWhenNoItemsSelected="activePinboardConfig.hideRightWhenEmpty"
                  side="right"
                ></pinboard-panel>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <div class="app-layout__footer" v-if="!isSimpleLayout">
      <app-footer></app-footer>
    </div>
    <div class="app-layout__bottom-nav" v-if="false">
      <app-bottom-nav :key="$route.path" :showIcons="true"></app-bottom-nav>
    </div>
    <nav-browse-categories-overlay></nav-browse-categories-overlay>
  </div>
</template>

<script src="./app-layout.js"></script>
<style src="./app-layout.scss" lang="scss"></style>
